import React , {useEffect} from 'react';

//*Mui
import { Box, Modal } from '@mui/material';

//*files
import Close from '../../Components/Icons/Close';
import cssClasses from "./ViewCollateralDetails.module.css";
import PDFIcon from '../../Assets/Images/CollateralIcons/PDF.svg';
import DOCIcon from '../../Assets/Images/CollateralIcons/DOC.svg';
import XLSIcon from '../../Assets/Images/CollateralIcons/XLS.svg';
import Mp4Icon from '../../Assets/Images/CollateralIcons/MP4.svg';
import PPTIcon from '../../Assets/Images/CollateralIcons/PPT.svg';

function ViewCollateralDetails({open , handleClose , data}) {
    const style = {
        position: 'absolute',
        top: '45%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        height: 'fit-content',
        bgcolor: 'background.paper',
        borderRadius: '8px',
        boxShadow: 24,
      }

      useEffect(() => {
      console.log(data)
      }, [])
      

  return (
    <>
    <Modal open={open} onClose={handleClose}>
       <Box sx={style}>
       <Box className={cssClasses.headerDiv}>
           <Box className={cssClasses.flexRow}>
             <Box className={cssClasses.flexCol}>
               <Box className={cssClasses.HeaderTitle} mt={1}>
                 Collateral Details
               </Box>{' '}
             </Box>
             <Box
               ml={'auto'}
               mt={1}
               onClick={handleClose}
               style={{ cursor: 'pointer' }}
             >
               <Close width={'1.2rem'} height={'1.2rem'} />
             </Box>
           </Box>
         </Box>

         <Box  height={"85%"} overflow={"auto"}>
           <Box className={cssClasses.flexRow} margin={'3.5rem'}>
           <Box mt={1}>
             <Box className={cssClasses.semiBoldTitle}>
             Document Name: <Box  className={cssClasses.BoldTitle}>  
             {data?.collateralUrl?.split('/')[2]
                              ? data?.collateralUrl?.split('/')[2]
                              : '-'}</Box>
            </Box>
            <Box className={cssClasses.semiBoldTitle}>
              Start Date :
              <Box  className={cssClasses.BoldTitle}> {new Date(data.projectCollateralId[0].startDateTime).toDateString()},{' '}
                          {new Date(data.projectCollateralId[0].startDateTime).toLocaleTimeString([], {
                            hour: '2-digit',
                            minute: '2-digit',
                          })}</Box>
            </Box>
            <Box className={cssClasses.semiBoldTitle}>
              End Date :
              <Box  className={cssClasses.BoldTitle}> {new Date(data.projectCollateralId[0].endDateTime).toDateString()},{' '}
                          {new Date(data.projectCollateralId[0].endDateTime).toLocaleTimeString([], {
                            hour: '2-digit',
                            minute: '2-digit',
                          })}</Box>
            </Box>
           </Box>
           
           <Box>
          <Box className={cssClasses.wrapperDocument}>
             {/* PDF */}
             {data?.collateralUrl?.split('.').pop() === 'pdf' && (
                            <div className={cssClasses.wrapperIconBlock}>
                              <img src={PDFIcon} alt='pdfIcon' />
                            </div>
                          )}
                          {/* Image */}
                          {data?.collateralUrl?.split('.').pop() === 'webp' && (
                            // eslint-disable-next-line jsx-a11y/img-redundant-alt
                            <div className={cssClasses.wrapperIconBlock1}>
                              <img
                                style={{
                                  height: '15rem',
                                  objectFit: 'fill',
                                }}
                                src={
                                  process.env.REACT_APP_SUPABASE_BUCKET_PREFIX +
                                  data?.collateralUrl
                                }
                                alt='img'
                              />
                            </div>
                          )}
                          {/* DOCS */}
                          {data?.collateralUrl?.split('.').pop() === 'docx' && (
                            <div className={cssClasses.wrapperIconBlock}>
                              <img src={DOCIcon} alt='docsIcon' />
                            </div>
                          )}
                          {/* XLS */}
                          {data?.collateralUrl?.split('.').pop() === 'xls' && (
                            <div className={cssClasses.wrapperIconBlock}>
                              <img src={XLSIcon} alt='xlsIcon' />
                            </div>
                          )}
                          {/* Video */}
                          {data?.collateralUrl?.split('.').pop() === 'mp4' && (
                            <div className={cssClasses.wrapperIconBlock}>
                              <img src={Mp4Icon} alt='mp4Icon' />
                            </div>
                          )}
                          {/* PPT */}
                          {/* Video */}
                          {data?.collateralUrl?.split('.').pop() === 'ppt' && (
                            <div className={cssClasses.wrapperIconBlock}>
                              <img src={PPTIcon} alt='pptIcon' />
                            </div>
                          )}
          </Box>
           </Box>
           </Box>
           
           <Box margin={'3.5rem'}>
           <Box className={cssClasses.FirstTitle}>
             Channel Partners : 
             <Box className={cssClasses.semiBoldTitle} mb={2}>
                {data?.projectCollateralId.map((el,index) => (
                    <Box mb={0.5} key={`${el}_${index}`} >
                    <Box className={cssClasses.semiBoldTitle} >{index+1}.<Box  component={'span'}  className={cssClasses.BoldTitle}>{el.cpId.billingName}</Box> </Box>
                    
                    </Box>
                    
                )) }</Box>
           </Box>

           </Box>
           
         </Box>
       </Box>
       </Modal>
   </>
  )
}

export default ViewCollateralDetails